import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { IconSize, Icons, TagColor } from '../enums';
import Button from './Button';

const StyledTag = styled.div`
  ${tw`select-none inline-flex bg-white rounded-md backdrop-blur`};
`;

const BackgroundColor = styled.div`
  ${tw`select-none inline-flex gap-1.5 px-2 py-1 items-center rounded-md border-2 text-xs`};
  width: auto;

`;

const colorClasses = {
  [TagColor.primary]:
    'bg-primary/20 border-primary/75 text-primary active:outline-primary/20',
  [TagColor.blue]:
    'bg-blue-500/20 border-blue-500/75 text-blue-600 active:outline-blue-500/20',
  [TagColor.orange]:
    'bg-orange-500/20 border-orange-500/75 text-orange-600 active:outline-orange-500/20',
  [TagColor.purple]:
    'bg-purple-500/20 border-purple-500/75 text-purple-600 active:outline-purple-500/20',
  [TagColor.green]:
    'bg-green-500/20 border-green-500/75 text-green-600 active:outline-green-500/20',
  [TagColor.emerald]:
    'bg-emerald-500/20 border-emerald-500/75 text-emerald-600 active:outline-emerald-500/20',
  [TagColor.cyan]:
    'bg-cyan-500/20 border-cyan-500/75 text-cyan-600 active:outline-cyan-500/20',
  [TagColor.indigo]:
    'bg-indigo-500/20 border-indigo-500/75 text-indigo-600 active:outline-indigo-500/20',
  [TagColor.violet]:
    'bg-violet-500/20 border-violet-500/75 text-violet-600 active:outline-violet-500/20',
  [TagColor.pink]:
    'bg-pink-500/20 border-pink-500/75 text-pink-600 active:outline-pink-500/20',
  [TagColor.amber]:
    'bg-amber-500/20 border-amber-500/75 text-amber-600 active:outline-amber-500/20',
  [TagColor.red]:
    'bg-red-500/20 border-red-500/75 text-red-600 active:outline-red-500/20',
};

interface Props {
  label: string[];
  id: string;
  color: TagColor;
  key?: string;
  className?: string;
  handleClick?: (label: string) => void;
}

const Tag: FC<Props> = ({ label, color, id, className, handleClick }) => {
	return (
		<StyledTag className={className}>
			<BackgroundColor className={`flex ${colorClasses[color]}`}>
        {label.map((item) => (<span key={item}>{item}</span>
        ))}
				{handleClick && (
					<Button
						className={`text-${color}-600`}
						icon={Icons.cross}
						iconSize={IconSize.extraSmall}
						onClick={() => handleClick(id)}
					/>
				)}
			</BackgroundColor>
		</StyledTag>
	);
};


const TagColorsByIndex = [
  TagColor.primary,
  TagColor.blue,
  TagColor.orange,
  TagColor.purple,
  TagColor.green,
  TagColor.emerald,
  TagColor.cyan,
  TagColor.indigo,
  TagColor.violet,
  TagColor.pink,
  TagColor.amber,
  TagColor.red,
];

export { Tag, TagColorsByIndex };
